import React from 'react';
import PropTypes from 'prop-types';
import Form from '../../../components/user/task/taskForm';
import Layout from '../../../components/layouts/verticalLayout';
import { useParams } from 'react-router-dom';

const TaskFormPage = () => {
  let { uuid } = useParams();
  return <Layout body={<Form uuid={uuid} />} />;
};

TaskFormPage.propTypes = {};

export default TaskFormPage;
